import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = {
  // Hubs
  getHubs: () => axios.get(`${API}/hubs`).then(r => r.data),
  createHub: (data) => axios.post(`${API}/hubs`, data).then(r => r.data),

  // Sites
  getSites: (hubId) => axios.get(`${API}/sites?hub_id=${hubId}`).then(r => r.data),
  createSite: (data) => axios.post(`${API}/sites`, data).then(r => r.data),
  updateSite: (siteId, data) => axios.put(`${API}/sites/${siteId}`, data).then(r => r.data),
  deleteSite: (siteId) => axios.delete(`${API}/sites/${siteId}`).then(r => r.data),

  // Machines
  getMachines: (hubId) => axios.get(`${API}/machines?hub_id=${hubId}`).then(r => r.data),
  createMachine: (data) => axios.post(`${API}/machines`, data).then(r => r.data),
  updateMachine: (machineId, data) => axios.put(`${API}/machines/${machineId}`, data).then(r => r.data),
  deleteMachine: (machineId) => axios.delete(`${API}/machines/${machineId}`).then(r => r.data),

  // Drivers
  getDrivers: (hubId) => axios.get(`${API}/drivers?hub_id=${hubId}`).then(r => r.data),
  createDriver: (data) => axios.post(`${API}/drivers`, data).then(r => r.data),
  updateDriver: (name, data) => axios.put(`${API}/drivers/${name}`, data).then(r => r.data),
  deleteDriver: (name, hubId) => axios.delete(`${API}/drivers/${name}?hub_id=${hubId}`).then(r => r.data),
  toggleShift: (name, hubId, action) => axios.post(`${API}/drivers/${name}/shift?hub_id=${hubId}&action=${action}`).then(r => r.data),

  // Requests
  getRequests: (hubId) => axios.get(`${API}/requests?hub_id=${hubId}`).then(r => r.data),
  createRequest: (data) => axios.post(`${API}/requests`, data).then(r => r.data),
  approveRequest: (reqId, driverName) => axios.put(`${API}/requests/${reqId}/approve?driver_name=${driverName}`).then(r => r.data),
  confirmDelivery: (data) => axios.post(`${API}/requests/deliver`, data).then(r => r.data),

  // Events
  getEvents: (hubId, limit = 50) => axios.get(`${API}/events?hub_id=${hubId}&limit=${limit}`).then(r => r.data),
  createEvent: (data) => axios.post(`${API}/events`, data).then(r => r.data),

  // Messages
  getMessages: (hubId, user = "") => axios.get(`${API}/messages?hub_id=${hubId}&user=${user}`).then(r => r.data),
  sendMessage: (data) => axios.post(`${API}/messages`, data).then(r => r.data),
  markRead: (msgId) => axios.put(`${API}/messages/${msgId}/read`).then(r => r.data),

  // Feedback
  getFeedback: (hubId) => axios.get(`${API}/feedback?hub_id=${hubId}`).then(r => r.data),
  sendFeedback: (data) => axios.post(`${API}/feedback`, data).then(r => r.data),

  // High Five
  sendHighFive: (data) => axios.post(`${API}/highfive`, data).then(r => r.data),

  // Translate
  translate: (text, targetLang, sourceLang = "en") =>
    axios.post(`${API}/translate`, { text, target_lang: targetLang, source_lang: sourceLang }).then(r => r.data),

  // Seed
  seed: () => axios.post(`${API}/seed`).then(r => r.data),
};

export default api;
